import {v4 as uuidv4} from 'uuid';
import {
    localStorageTwoFactorUUIDVariable,
    // sessionStorageTokenVariable,
    // sessionStorageTwoFactorTokenVariable
} from "@/types/constants";

class BrowserSettingsService {

    // constructor() {
    // }

    // localstorage
    setLocalStoragePropertyValue(property: string, value: string) {
        if (window.localStorage) {
            window.localStorage.setItem(property, value);
        }
    }

    getLocalStoragePropertyValue(property: string) {
        return window.localStorage ? window.localStorage.getItem(property) : '';
    }

    // sessionstorage
    // getSessionStoragePropertyValue(property: string,) {
    //     return window.sessionStorage ? window.sessionStorage.getItem(property) : '';
    // }

    // removeSessionStoragePropertyValue(property: string) {
    //     if (window.sessionStorage) {
    //         window.sessionStorage.removeItem(property);
    //     }
    // }

    // setSessionStoragePropertyValue(property: string, value: string) {
    //     if (window.sessionStorage) {
    //         return window.sessionStorage.setItem(property, value);
    //     }
    // }

    // storage TwoFactorAuth variables

    generateLocalStorageTwoFactorUUIDVariable() {
        return uuidv4();
    }

    setLocalStorageTwoFactorUUIDVariable(value: string) {
        this.setLocalStoragePropertyValue(localStorageTwoFactorUUIDVariable, btoa(value));
    }

    generateAndSetLocalStorageTwoFactorUUIDVariable() {
        // console.log('no existe deviceid y se genera nuevo uuid');
        const uuid = this.generateLocalStorageTwoFactorUUIDVariable();
        this.setLocalStorageTwoFactorUUIDVariable(uuid);
        return uuid;
    }

    getLocalStorageTwoFactorUUIDVariable() {
        const value = this.getLocalStoragePropertyValue(localStorageTwoFactorUUIDVariable);
        // console.log('getLocalStorageTwoFactorUUIDVariable. value: ' + value);
        try {
            const valueDecod = value ? atob(value) : null;
            if (!valueDecod || (valueDecod && valueDecod.length !== 36)) {
                // console.log('no hay uuid correcto');
                return this.generateAndSetLocalStorageTwoFactorUUIDVariable();
            } else {
                // console.log('valueDecod: ' + valueDecod);
                return valueDecod;
            }
        } catch (e) { // catch exceptions from atob function
            // console.log('excepcion atob');
            return this.generateAndSetLocalStorageTwoFactorUUIDVariable();
        }
    }

    // getSessionStorageTwoFactorTokenVariable() {
    //     const value = this.getSessionStoragePropertyValue(sessionStorageTwoFactorTokenVariable);
    //     return value ? value : null;
    // }
    //
    // getsessionStorageTokenVariable() {
    //     const value = this.getSessionStoragePropertyValue(sessionStorageTokenVariable);
    //     return value ? value : null;
    // }

}

export default new BrowserSettingsService();
